import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { CHART_CHROME } from "@/shared/ui/chart/public";
import { MAGNITUDE_FILL, MARK, UNKNOWN_FILL } from "./chartTheme";
import type { CountColumnChartProps } from "./contract";

/**
 * 순서형 축의 분포를 세로 컬럼으로 표시한다. 카메라 스트림 수처럼 값 자체에 순서가 있는 축에 쓴다.
 *
 * 값 순서가 의미를 가지므로 개수 내림차순으로 다시 정렬하지 않는다(호출부가 이미 값 오름차순으로
 * 전달한다). 색은 단일 hue 이고, 미판정 묶음만 중립색이다.
 */
export function CountColumnChart({ data, formatCount, axisLabel }: CountColumnChartProps) {
  const columns = data.map((datum) => ({
    key: datum.key,
    label: datum.label,
    count: datum.count,
    fill: datum.unknown === true ? UNKNOWN_FILL : MAGNITUDE_FILL,
  }));
  return (
    <ResponsiveContainer width="100%" height={180}>
      <BarChart data={columns} margin={{ top: 8, right: 8, bottom: 16, left: 0 }}>
        <CartesianGrid stroke={CHART_CHROME.grid} vertical={false} />
        <XAxis
          dataKey="label"
          interval={0}
          tickLine={false}
          axisLine={false}
          stroke={CHART_CHROME.axis}
          fontSize={MARK.tickFontSize}
          label={{
            value: axisLabel,
            position: "insideBottom",
            offset: -12,
            fontSize: MARK.tickFontSize,
            fill: CHART_CHROME.axis,
          }}
        />
        <YAxis
          width={40}
          allowDecimals={false}
          tickLine={false}
          axisLine={false}
          stroke={CHART_CHROME.axis}
          fontSize={MARK.tickFontSize}
        />
        <Tooltip
          cursor={false}
          formatter={(value: number) => [formatCount(value), "Dataset"]}
          contentStyle={{
            background: CHART_CHROME.tooltipBg,
            border: `1px solid ${CHART_CHROME.tooltipBorder}`,
            borderRadius: MARK.radius,
            color: CHART_CHROME.tooltipInk,
            fontSize: MARK.tickFontSize,
          }}
          itemStyle={{ color: CHART_CHROME.tooltipInk }}
        />
        <Bar dataKey="count" radius={[MARK.radius, MARK.radius, 0, 0]} isAnimationActive={false}>
          {columns.map((column) => (
            <Cell key={column.key} fill={column.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
